import { Swiper, SwiperSlide } from 'swiper/react';
import { Scrollbar, Navigation } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function O() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('vanliferoadtrips');
    const { locale } = useRouter();
    const listsAll: any = [
        {
            title: t('secO_list1_title'),
            desc: t('secO_list1_desc'),
        },
        {
            title: t('secO_list2_title'),
            desc: t('secO_list2_desc'),
        },
        {
            title: t('secO_list3_title'),
            desc: t('secO_list3_desc'),
        },
        {
            title: t('secO_list4_title'),
            desc: t('secO_list4_desc'),
        },
    ];

    const lists = ['za'].includes(locale) ? [listsAll[0], listsAll[1]] : [...listsAll];

    if (['fr'].includes(locale)) {
        lists.push({
            title: t('secO_list5_title'),
            desc: t('secO_list5_desc'),
        });
    }

    return (
        <div id="vanlife-roadtrips-O" className={`vanlife-roadtrips-O ${css['vanlife-roadtrips-O']}`}>
            <div className="ef-box">
                <div className="text-box">
                    <p className="title">{t('secO_title')}</p>
                </div>
                <Swiper
                    className="swiper-box"
                    effect="fade"
                    modules={[Scrollbar, Navigation]}
                    navigation={true}
                    spaceBetween={0}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {lists?.map((card: any, k: number) => (
                        <SwiperSlide className={`swiper-item item-${k + 1}`} key={k}>
                            <div className="swiper-item-text">
                                <p className="card-desc">{card?.desc}</p>
                                <p className="card-title">{card?.title}</p>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
}
